import React, { useState } from "react";
import styles from "./styles.module.scss";

/**
 * Write-only secret field. Shows "Configured" when a value exists,
 * with a "Change" button to enter a new value. The actual secret is
 * never returned from the backend.
 *
 * Props:
 *   configured: boolean (from backend *Configured flag)
 *   fieldName: string key used in the onChange callback
 *   onChange: (fieldName, newValue) => void
 *   label: display label (optional, for textarea mode)
 *   multiline: if true, renders a textarea instead of input
 */
const SecretField = ({ configured, fieldName, onChange, multiline }) => {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState("");

    const handleSave = () => {
        if (value.trim()) {
            onChange(fieldName, value);
        }
        setEditing(false);
        setValue("");
    };

    const handleCancel = () => {
        setEditing(false);
        setValue("");
    };

    if (!editing) {
        return (
            <div className={styles.secretField}>
                <span className={configured ? styles.secretConfigured : styles.secretNotConfigured}>
                    {configured ? "Configured" : "Not configured"}
                </span>
                <button className={styles.detailBtn} onClick={() => setEditing(true)}>
                    {configured ? "Change" : "Set"}
                </button>
            </div>
        );
    }

    return (
        <div className={styles.secretField}>
            {multiline ? (
                <textarea
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder="Paste new value..."
                    className={styles.secretTextarea}
                    rows={3}
                />
            ) : (
                <input
                    type="password"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder="Enter new value..."
                    className={styles.configInput}
                    autoFocus
                />
            )}
            <button className={styles.primaryBtn} onClick={handleSave} disabled={!value.trim()}>
                Save
            </button>
            <button className={styles.detailBtn} onClick={handleCancel}>
                Cancel
            </button>
        </div>
    );
};

export default SecretField;
